@if (showClock && !clockBarDismissed) {
  <app-clock-bar (dismissed)="dismissClockBar()"></app-clock-bar>
}

<div
  class="modal-header p-3 d-flex align-items-center justify-content-between position-relative"
  [ngStyle]="{ 'background-color': titlesUseSureSimBlue ? '#47568C' : '#e9ecf1', 'color': titlesUseSureSimBlue ? 'white' : 'black' }"
  (mousedown)="headerOnMouseDown($event)"
>
  <div class="d-flex align-items-center gap-2">
    
    @if (titlesUseSureSimBlue && (!curUser.branded || curUser.isUtelize)) {
      <img
        alt="Logo"
        class="me-2"
        [class.logo-grow-in]="sureSimLogoGrow"
        [height]="isPlatformModeInview ? 45 : 45"
        [src]="isPlatformModeInview ? 'assets/images/myinview-logo.png' : 'assets/images/SureSIM-Logo-Light-109.png'"
      >
    }
    
    <div class="d-flex align-items-center">
      <div class="d-flex flex-column me-2">
        <h4
          class="modal-title mb-0"
          [class.text-grow-in]="sureSimLogoGrow"
          id="formTitle"
          [ngStyle]="{ 'color': titlesUseSureSimBlue ? 'white' : 'black' }"
        >
          {{title}}
        </h4>

        @if (label0Show && label0Text != undefined) {
          <small
            class="fw-semibold"
            style="margin-top: 2px;"
            [ngStyle]="{ 'color': titlesUseSureSimBlue ? 'rgba(255,255,255,0.85)' : '#5563a0' }"
          >
            {{label0Text}}
          </small>
        }
      </div>

      @if (showFileLockIcon) {
        <button class="btn btn-message" (click)="fileLockButtonClick()" [title]="fileLockHoverText ?? ''">
          <i
            class="h3 bi bi-file-earmark-lock"
            [ngStyle]="{ color: titlesUseSureSimBlue ? 'white' : 'black' }"
          ></i>
        </button>
      }

      @if (showMessageIcon) {
        <button class="btn btn-message" (click)="messageButtonClick()" [title]="isCompanyModal ? 'Message Company' : 'Message User'">
          <i
            class="h3 bi bi-envelope"
            style="position: relative; top: 3px;"
            [ngStyle]="{ color: titlesUseSureSimBlue ? 'white' : 'black' }"
          ></i>
        </button>
      }

      @if (showMicrosoftIcon) {
        <button class="btn btn-message" title="Open AI via Azure">
          <i
            class="h3 bi bi-microsoft"
            [ngClass]="microsoftIconClass ?? ''"
            style="position: relative; top: 3px;"
            [ngStyle]="{ color: titlesUseSureSimBlue ? 'white' : 'black' }"
          ></i>
        </button>
      }

      @if (showOpenAiIcon) {
        <button class="btn btn-message" title="Open AI Direct">
          <i
            class="h3 bi bi-openai"
            style="position: relative; top: 3px;"
            [ngStyle]="{ color: titlesUseSureSimBlue ? 'white' : 'black' }"
          >
            <img src="assets/images/_images/OpenAI.png" alt="Header Image" height="25" class="rounded">
          </i>
        </button>
      }

      @if (showPadlockIcon) {
        <button
          class="btn btn-message"
          [title]="padlockIsLocked ? padlockLockedTitle : padlockUnlockedTitle"
          (click)="padlockButtonClick()"
        >
          <i
            class="h3"
            [ngClass]="{ 'bi bi-lock': padlockIsLocked, 'bi bi-unlock': !padlockIsLocked }"
            [ngStyle]="{ color: titlesUseSureSimBlue ? 'white' : 'black' }"
          ></i>
        </button>
      }

      @if (showReplyIcon) {
        <button class="btn btn-reply" (click)="replyButtonClick()" title="Reply">
          <i
            class="bi bi-reply"
            [ngStyle]="{ color: titlesUseSureSimBlue ? 'white' : 'black' }"
          ></i>
        </button>
      }

      @if (showTimelineIcon) {
        <button class="btn btn-timeline" (click)="timelineButtonClick()" title="Live View">
          <i
            class="h3 bi bi-clock"
            [ngStyle]="{ color: titlesUseSureSimBlue ? 'white' : 'black' }"
          ></i>
        </button>
      }

    </div>
  </div>

  @if (showCompanyDropdown) {
    <div class="d-flex ms-auto align-items-end gap-3 pe-5">
      <app-dropdown-company
        style="width: 400px;"
        [hasFeature]="hasFeature"
        [hideLabel]="hideCompanyDropdownLabel"
        [hierarchyFormatting]="hierarchyFormatting"
        [initialCompanyId]="initialCompanyId"
        [labelTop]="companyDropdownLabelTop"
        [showSelectAllOption]="showCompanyDropdownSelectAllOption"
        (selectOnChangeEvent)="companyDropDownOnChange($event)"
        (selectOnChangeEvent2)="companyDropDownOnChange2($event)"
      ></app-dropdown-company>
      
      @if (showClock && clockBarDismissed) {
        <app-clock-chip-group
          class="align-self-center"
          [editable]="clockEditable"
          [hideFlags]="false"
          [zoneKeys]="clockZoneKeys">
        </app-clock-chip-group>
      }
    </div>
  }

  @if (showHeaderActionIcon) {
    <button
      type="button"
      class="btn-header-action btn-header-action-position"
      [ngClass]="{ 'active': headerActionIsActive }"
      [attr.title]="headerActionTitle ?? ''"
      [attr.aria-label]="headerActionTitle ?? ''"
      (click)="headerActionButtonClick()"
    >
      <i class="bi" [ngClass]="headerActionIconClass ?? 'bi-pin-angle'"></i>
    </button>
  }

  @if ((showClock && clockBarDismissed && !showCompanyDropdown) || button0Show) {
    <div class="position-absolute top-50 translate-middle-y d-flex align-items-center gap-2" style="right: 4rem;">
      @if (showClock && clockBarDismissed && !showCompanyDropdown) {
        <app-clock-chip-group
          [editable]="clockEditable"
          [hideFlags]="false"
          [zoneKeys]="clockZoneKeys">
        </app-clock-chip-group>
      }
      @if (button0Show) {
        <button
          class="btn"
          [ngClass]="button0Danger ? 'btn-danger' : 'btn-success'"
          [disabled]="button0Disabled===true"
          id="modalCompHeaderButton0"
          type="button"
          (click)="button0OnClick()"
        >
          {{button0Text ? button0Text : "undefined button text"}}
        </button>
      }
    </div>
  }

  <button
    aria-label="Close"
    class="btn-close position-absolute top-0 end-0 m-3"
    data-bs-dismiss="modal"
    id="close-modal"
    type="button"
    [ngStyle]="{ filter: titlesUseSureSimBlue ? 'invert(1) grayscale(100%) brightness(200%)' : 'none' }"
    (click)="cancelButtonClick()"
  >
  </button>
</div>
